(function () {
  'use strict';

  /* ---------- 1. Galeria da PDP (thumb -> main) ---------- */
  document.querySelectorAll('[data-trelori-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main] img');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        if (full && main) { main.src = full; main.srcset = ''; }
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  });

  /* ---------- 2. Quantity stepper ---------- */
  document.querySelectorAll('[data-trelori-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var val = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, val);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- 3. Sticky add-to-cart (aparece ao rolar a buy box) ---------- */
  var sticky = document.querySelector('.trelori-sticky');
  var anchor = document.querySelector('[data-trelori-buybox]');
  if (sticky && anchor) {
    var io = new IntersectionObserver(function (entries) {
      // mostra quando a buy box principal saiu da tela
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' });
    io.observe(anchor);
    // o botão do sticky apenas reaproveita o submit do form principal
    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    var mainForm = anchor.closest('form') || document.querySelector('form[action$="/cart/add"]');
    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (typeof mainForm.requestSubmit === 'function') mainForm.requestSubmit();
        else mainForm.submit();
      });
    }
  }

  /* ---------- 4. Frete por CEP (cálculo real via taxas de envio da loja) ---------- */
  document.querySelectorAll('[data-trelori-frete]').forEach(function (box) {
    var input = box.querySelector('[data-frete-cep]');
    var btn = box.querySelector('[data-frete-calc]');
    var out = box.querySelector('[data-frete-result]');
    if (!input || !btn || !out) return;

    // Máscara CEP
    input.addEventListener('input', function (e) {
      var value = e.target.value.replace(/\D/g, '');
      if (value.length > 5) value = value.slice(0, 5) + '-' + value.slice(5, 8);
      e.target.value = value;
    });

    btn.addEventListener('click', async function () {
      var cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        showFreteMessage(out, 'erro', 'Digite um CEP válido.');
        return;
      }

      setFreteLoading(btn, true);
      try {
        var location = await getLocationByCep(cep);
        if (!location || !location.province) {
          showFreteMessage(out, 'erro', 'CEP não encontrado. Confira e tente novamente.');
          return;
        }
        await addTemporaryFreteProduct();
        await calculateShippingRates(cep, location.province, out);
        await fetch('/cart/clear.js', { method: 'POST' });
      } catch (error) {
        console.error(error);
        showFreteMessage(out, 'erro', 'Não foi possível calcular o frete. Tente novamente em instantes.');
      } finally {
        setFreteLoading(btn, false);
      }
    });
  });

  function setFreteLoading(btn, isLoading) {
    btn.disabled = isLoading;
    btn.textContent = isLoading
      ? (btn.dataset.loadingText || 'Calculando...')
      : (btn.dataset.text || 'Calcular');
  }

  function showFreteMessage(out, type, message) {
    out.hidden = false;
    out.innerHTML = '<div class="fr' + (type === 'erro' ? ' fr-erro' : '') + '"><span>' + message + '</span></div>';
  }

  async function addTemporaryFreteProduct() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var formData = new FormData(form);
    var data = {};
    formData.forEach(function (value, key) { data[key] = value; });
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(data)
    });
  }

  async function getLocationByCep(cep) {
    try {
      var res = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
      if (!res.ok) return null;
      var data = await res.json();
      if (data.erro) return null;
      return { province: data.uf };
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async function calculateShippingRates(cep, province, out) {
    var url = '/cart/shipping_rates.json' +
      '?shipping_address[zip]=' + encodeURIComponent(cep) +
      '&shipping_address[country]=BR' +
      '&shipping_address[province]=' + encodeURIComponent(province);

    var response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      showFreteMessage(out, 'erro', 'Não foi possível encontrar opções de frete para o CEP informado.');
      return;
    }

    var data = await response.json();
    if (!data.shipping_rates || !data.shipping_rates.length) {
      showFreteMessage(out, 'erro', 'Não encontramos opções de frete para o CEP informado.');
      return;
    }

    var rowsHtml = data.shipping_rates.map(function (rate) {
      var price = parseFloat(rate.price);
      var priceLabel = !price ? '<span class="free">Grátis</span>' : formatCurrency(price);
      var days = rate.delivery_days && rate.delivery_days.length ? formatDeliveryDays(rate.delivery_days) : '';
      return '<div class="fr"><span>' + rate.name + (days ? ' <small>&middot; ' + days + '</small>' : '') + '</span>' +
             '<span>' + priceLabel + '</span></div>';
    }).join('');

    out.hidden = false;
    out.innerHTML =
      '<div class="fr fr-cep"><span>CEP: ' + formatCep(cep) + '</span>' +
      '<button type="button" class="fr-change" data-frete-change>Alterar</button></div>' +
      rowsHtml;

    var changeBtn = out.querySelector('[data-frete-change]');
    var zipInput = out.closest('[data-trelori-frete]').querySelector('[data-frete-cep]');
    if (changeBtn && zipInput) {
      changeBtn.addEventListener('click', function () {
        out.hidden = true;
        out.innerHTML = '';
        zipInput.focus();
        zipInput.select();
      });
    }
  }

  function formatDeliveryDays(deliveryDays) {
    var lastDay = deliveryDays[deliveryDays.length - 1];
    return lastDay === 1 ? '1 dia útil' : lastDay + ' dias úteis';
  }

  function formatCurrency(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  function formatCep(cep) {
    return cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
  }
})();
